export default "{\n    \"label\": \"Team Member\",\n    \"label_plural\": \"{{count}} Team Members\"\n}\n"